
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useRequest } from 'ahooks';

import raysserveapi from '@/api/raysserveapi';
import { Image, Progress } from '@/components/AntD';
import SvgaPlayer from '@/components/SvgaPlayer';

import './MobileDubWarp.scss';

export default function MobileDubWarp() {

  const { data: tabs = [] } = useRequest(() => raysserveapi.getNameList());
  const { data = [], run: getVoicerList } = useRequest((value) => raysserveapi.categoryList(value), { manual: true });
  const audioRef = useRef(null);
  const [itemId, setItemId] = useState(0);

  const [playing, setPlaying] = useState(false);
  const [playInfo, setPlayInfo] = useState({});
  const [percent, setPercent] = useState(0);
  //range值
  const [range, setRange] = useState(1);
  const scrollContainerRef = useRef(null);
  const progressBarRef = useRef(null);
  const [isVisible,setIsVisible]=useState(true);
  //滚动元素宽度
  useEffect(() => {
    if (tabs.length) {
      changeTab(tabs[0].categoryId);
    }
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      const { scrollLeft, scrollWidth} = scrollContainer;
      const scrollWidthTrue=scrollWidth-window.innerWidth;
      setRange(Math.ceil(( scrollLeft / scrollWidthTrue) * 10));
    };
    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [tabs]);



  const changeTab = (value) => {
    setItemId(value);
    const params = {
      'languageId': '',
      'categoryId': value,
      'voicerSex': '',
      'ageGroup': '',
      'query': ''
    };
    getVoicerList(params);

    //新闻，儿童卡片数量小于3，不显示滚动条
    if(value===102||value===95){
      setIsVisible(false);
    }else{
      setIsVisible(true);
    }
    //点击标签后滚动回最左端
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        left: 0,
        behavior: 'smooth',
      });
    }

  };

  const changePlay = (value, play) => {
    if (value.id === playInfo.id) {
      play ? audioRef.current.play() : audioRef.current.pause();
    } else {
      audioRef.current.src = value.hiAudioUrl;
      audioRef.current.play();
    }
    setPlaying(play);
    setPlayInfo(value);
  };

  const onTimeUpdate = () => {
    setPercent(Math.floor(audioRef.current.currentTime * 100 / audioRef.current.duration));
  };

  const onEnded = () => {
    setPlaying(false);
    setPlayInfo({});
  };

  return (
    <div className="DubWarp-mobile">
      <div className="DubWarp-mobile-content">
        <div className="top-warp">
          {
            tabs.map((item, index) => {
              return (
                <div onClick={() => changeTab(item.categoryId)} className={classNames('tab-item', { 'active': itemId === item.categoryId })} key={index}>
                  {item.categoryName}
                  <div className={classNames('active-line', { 'active': itemId === item.categoryId })}></div>
                </div>
              );
            })
          }
        </div>
        <div className="bottom-warp">
          <div className="bottom-warp-scroll" ref={scrollContainerRef}>
            {
              data.length && data[0].speakerList.map((item, index) => {
                return (
                  <div className={`data-item`} key={index}>
                    <div className="item-warp">
                      <div className="item-warp-left">
                        <Image src={item.voicerHeadUrl} width={36} preview={false} />
                        <div className="base-info">
                          <div className="voicerShowName">{item.voicerShowName}</div>
                          {item.languageId !== 1 && item.language && <div className="langName">{item.language}</div>}
                          {!(item.languageId !== 1 && !item.voicerStyle) && <div className="language-desc">{item.voicerStyle}</div>}
                        </div>
                      </div>
                      {
                        playing && item.id === playInfo.id ?
                          <Progress
                            type="circle"
                            percent={percent}
                            width={24}
                            height={24}
                            strokeColor="#006AFF"
                            strokeWidth={10}
                            trailColor="#cce1ff"
                            format={percent => <div onClick={() => changePlay(item, false)} style={{ width: '12px', height: '12px' }}>
                              <SvgaPlayer svgaUrl="https://oss.5rs.me/oss/uploadfe/svga/videoplay.svga" />
                            </div>}
                          /> :
                          <Image className="play-img" onClick={() => changePlay(item, true)} src={PLAY_IMG} width={20} preview={false} />
                      }
                    </div>
                    {item.categoryInfo && <div className="voicerStyle">
                      {
                        item.categoryInfo && item.categoryInfo.map((label, index) => {
                          return <span key={ index }>{label} {index === (item?.categoryInfo?.length - 1) ? '' : <i className="line" />} </span>;
                        })
                      }
                    </div>}
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
      <input className={`progress-bar ${isVisible?"visible":"unvisible"}`} ref={progressBarRef} type='range' value={range} min='1' max={10} step='1'></input>
      <audio ref={audioRef} onTimeUpdate={onTimeUpdate} onEnded={onEnded} />
    </div>
  );
}

const PLAY_IMG = 'https://oss.5rs.me/oss/uploadfe/png/1c4257f91e8701d1b4c7261e62ace52f.png';

const ICON_IMG = 'https://oss.5rs.me/oss/uploadfe/png/f8aa067d2ee41847300b6c762e703867.png';